import { configureStore } from "@reduxjs/toolkit";
import profileReducer from "./profileSlice";
import businessReducer from './businessSlice';
import businessProfileReducer from './businessProfileSlice';
import businessProfileByIdReducer from './businessProfileByIdSlice';
import businessSummaryReducer  from './businessSummarySlice';

const store = configureStore({
  reducer: {
    profile: profileReducer,
    business: businessReducer,
    businessProfile: businessProfileReducer, 
    businessProfileById: businessProfileByIdReducer,
    // businessSummary: businessSummaryReducer,
  },
});

export default store;

